import { ContentBox } from '$comp/navigation-bar-tool-box/components/content-box'
import { CulturalContentsIcon } from '$common/icons/navitation-bar-tool-box/cultural-contents'
import { t } from '$i18n'

export function CulturalContents({ onClick }: { onClick: () => unknown }) {
  return (
    <ContentBox
      title={t('wapps.multimedia')}
      description={t('navigationBarToolBox.culturalContents.description')}
      rootSx={{
        background: 'linear-gradient(180deg, #9445EC 0%, #2782ED 100%)',
      }}
      icon={<CulturalContentsIcon />}
      onClick={onClick}
    />
  )
}
